<template>
<div>
  <!-- page wrapper start -->
	<div class="pg-wrapper location-product-detail-v2-wrapper">
    <app-header>
      <div class="title-bar" slot="header-foot">
        <div class="nav-bar-wrapper">
          <div class="nab-bar-left">
            <button @click="goBack()" class="button is-flex nav-back">
              <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back" />
            </button>
       
             <div class="mb0 title-bar-breadcrumb mt0 product-detail-breadcrumb has-text-dark">
              <span class="has-text-dark pointer hover-opacity-7" @click.prevent="moveToPage('StoreLanding')">Home <i class="fa fa-angle-right" aria-hidden="true"></i> </span>
              <span class="has-text-dark  pointer hover-opacity-7" @click.prevent="moveToPage('StoreProfile')">Shop <i class="fa fa-angle-right" aria-hidden="true"></i> </span>
              <span class="has-text-dark pointer hover-opacity-7" v-if="productDetail.category" @click.prevent="moveToPage('StoreProfile', { category: productDetail.category.name } )"> {{ productDetail.category.name }} <i class="fa fa-angle-right" aria-hidden="true"></i>&nbsp;</span>Product
            </div>
          </div>
          <div class="nav-bar-right">
          </div>
        </div>
      </div> 

    </app-header>
    
		<main class="content-wrapper pt30">

      <template v-if="!loaded">
        <div  class="location-product-detail-content-main">
          <div class="container xl">
            <location-product-detail-skeleton />
          </div>
        </div>
      </template>

      <template v-else>
        <div  class="location-product-detail-main">
          <div class="container xl">

            <div class="columns is-mobile justify-content-between is-hidden-downto-992">
                <div class="column">
                  <h2 class="is-size-20px is-line-height-24px has-text-weight-semibold">{{ productDetail.name }}</h2>
                  <p class="company-name is-size-12px mt10 is-uppercase" v-if="productDetail.brand && (productDetail.brand.name != 'No Brand')">{{ productDetail.brand.name }}</p>
                </div>
                <div class="column">
                  <p class="starting-price is-size-12px has-text-right"><span class="has-text-grey">Starting at </span> <span class="is-size-20px is-line-height-24px has-text-weight-semibold">${{ productFirstVariantPrice }}</span></p>
                </div>
            </div>

            <div class="columns justify-content-between is-multiline">
              <div class="column is-product-image-col">
                <featured-image-slider
                  v-if="productDetail" 
                  :productimages="productDetail.images"
                  :productname="productDetail.name"
                  :productvariants="availableVariants"
                />
              </div>

              <div class="column is-product-detail-thc-col">
                <!-- thc cbd only for cannabis product -->
                <thc-cbd 
                :product="productDetail"
                v-if="productDetail && productDetail.thc_cbd_levels && (productDetail.product_family == 'cannabis')"/>
              </div>

              <div class="column is-product-detail-stash-col">
                <add-to-stash-desktop 
                v-if="productDetail && productDetail.id"
                :productvariants="availableVariants"
                :outofStockSubscribeVariants='outofStockSubscribeVariants'
                :productdetail="productDetail" />
              </div>
            
            </div>
          </div>
        </div>

        <div class="location-product-detail-content">
          <div class="container xl">
            <div class="columns is-multiline">
              
              <div class="column is-12" v-if="productDetail && (productDetail.description || (productDetail.aromas && (productDetail.aromas.length > 0)) ||  (productDetail.terpenes && (productDetail.terpenes.length > 0)) )">
                <h2 class="is-size-34px has-text-weight-semibold text-center">About This Product</h2>
              </div>

              <div class="column is-12" v-if="productDetail && productDetail.description">
                 <description 
                 :description="productDetail.description"
                 />
              </div>  

              <div class="column is-12" v-if="productDetail && (productDetail.product_family == 'cannabis') && productDetail.aromas && (productDetail.aromas.length > 0)">
                <aromas 
                 :aromas="productDetail.aromas"
                 />
              </div>  

              <div class="column is-12" v-if="productDetail && productDetail.terpenes && (productDetail.terpenes.length > 0) && (productDetail.product_family == 'cannabis')">
                <terpenes 
                 :terpenes="productDetail.terpenes"
                 />
              </div>  

            </div>
          </div>
        </div>

        <recommend-products :recommendproducts="recommendProducts" v-if="recommendProducts.length > 0"/>

      </template>

		</main>
    
    <out-of-stock-alert />
    <app-footer></app-footer>
   
    <mobile-footer-actions 
      v-if="loaded" 
      :productdetail="productDetail"
      :productvariants='availableVariants'
      :outofStockSubscribeVariants='outofStockSubscribeVariants'
    />

	</div>
</div>
</template>
<script>


import LocationProductDetailSkeleton from '@/Components/Pages/PageComponents/LocationProductDetailNew/Skeleton';
import FeaturedImageSlider from '@/Components/Pages/PageComponents/LocationProductDetailNew/FeaturedImageSlider';
import ThcCbd from '@/Components/Pages/PageComponents/LocationProductDetailNew/ThcCbd';
import AddToStashDesktop from '@/Components/Pages/PageComponents/LocationProductDetailNew/AddToStashDesktop';
import Description from '@/Components/Pages/PageComponents/LocationProductDetailNew/Description';
import Aromas from '@/Components/Pages/PageComponents/LocationProductDetailNew/Aromas';
import Terpenes from '@/Components/Pages/PageComponents/LocationProductDetailNew/Terpenes';
import RecommendProducts from '@/Components/Pages/PageComponents/LocationProductDetailNew/RecommendProducts';
import OutOfStockAlert from '@/Components/Pages/PageComponents/LocationProductDetailNew/OutOfStockAlert';
import MobileFooterActions from '@/Components/Pages/PageComponents/LocationProductDetailNew/MobileFooterActions';

/**
 * Popups
 */
import CartApis from '@/Components/Controllers/CartApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import LocationApis from '@/Components/Controllers/LocationApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';

import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';

export default {
 components: {
    LocationProductDetailSkeleton,
    FeaturedImageSlider,
    ThcCbd,
    AddToStashDesktop,
    Description,
    Aromas,
    Terpenes,
    RecommendProducts,
    MobileFooterActions,
    OutOfStockAlert
  },
  name: 'ProductDetailNew',
  metaInfo() {
    return { 
      title: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,
      meta: [
        { name: 'description', content:  `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
        { property: 'og:title', content: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
      ]
    }
  },
  data() {
    return {
      loaded: false,
      productDetail: {},
      outOfStock: false,
      favDetail: {},
      recommendProducts: [],
      outofStockSubscribeVariants: [],
    };
  },

  computed: {
    availableVariants() {
      return this.selectedLocationVariants(this.productDetail.variants);
    },

    productFirstVariantPrice() {
      let variants = this.availableVariants;
      if(variants.length > 0){
        return this.variantPrice(variants[0]);
      }
      return 0.00;
    },

    ...mapGetters({
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_selectedStore: "location/selected",
      vg_userId: "getLoggedInUserId",
      vg_storeProfileRecord: "storeprofile/storeProfileRecord",
    }),
  },

  watch: {
    '$route.params.product_id'() {
      this.refetchProduct()
    },
   'vg_userId'(val){
      if(val){
        Helpers.setPubNubUserLocationSubscribe({ 
          user_id: val, 
          location_id: this.vg_selectedStore.id
       });
      }
    },
  },

  created() {
   
  },

  async mounted() {
    const self = this;
    // Fetch product detail
    let res = await ProductApis.fetchById(this.$route.params.product_id);
    if(res.status != 200){
      // if product doesnot exist back to Store profile route
      this.va_snackbar({
        type: "warning",
        message:  "Cannot find the product."
      });
      return this.$router.push({ 
        name: 'StoreProfile', 
        params: { 
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug
        },
        query: this.$route.query,
      })
    }

 

    // Fetch recommend products
     let recommendProductsRes = await ProductApis.fetchRecommendProductsByLocationProductIds({
        location_products_ids: [this.$route.params.product_id]
      }) 
      if(recommendProductsRes.status == 200){
        let collectrecommendProducts = Helpers.collectRecommendProducts(recommendProductsRes.data.payload, 3);
        if(collectrecommendProducts.length > 0) {
          this.recommendProducts = collectrecommendProducts;
        }
      }
    
    if(this.$store.getters.getLoggedInUserId){
      await UserApis.fetchFavProducts();
      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, this.vg_selectedStore.id, this.$route.query);
        setTimeout(()=> {
          Helpers.pubnubSubscribeAllChannels({ 
            user_id: this.$store.getters.getLoggedInUserId, 
            location_id: this.vg_selectedStore.id
          });
          Helpers.emitUserActivity();
        }, 1000)
      }
    }
    // Fetch cart in case of hard paste url
    CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));

    this.productDetail = res.data.payload;

    if(this.vg_userId){
      // Fetch out of stock variant datas
      this.fetchOutofStockSubscribeVariants();
    }
  

    this.loaded = true;
    // User might have hit direct link so let get location detail from given store_id
    
    // if(locationDetail.status == 200){
    //   // if the current selected location doesnot match with this product
    //  if(this.vg_selectedLocation.id != locationDetail.data.payload.id){
    //     // step 1 , set this location as active
    //     // step 2 , fetch cart for this location
    //  }
    // }
    
    if(this.$store.getters.getLoggedInUserToken){
      // lets save the data on vbout
      VboutApis.productView(this.productDetail, Helpers.getLocationProductFullUrl(this, this.productDetail.id), this.vg_selectedStore.id);
    } 


    bus.$on('refetch-outof-stock-notification', (payload) => {
      if(payload == true){
        this.fetchOutofStockSubscribeVariants();
      }
    })

  },

  beforeDestroy() {
    bus.$off('refetch-outof-stock-notification');
  },


  methods: {

     /**
     * Variant show sale price if on sale else regular price
     */
    variantPrice(item) {
      if(item.sale_price && (parseFloat(item.sale_price) < parseFloat(item.price)) ){
        return item.sale_price.toFixed(2);
      }
      return item.price.toFixed(2);
    },

    /**
     * Recommend product will need this 
     */
    async refetchProduct() {
       // Fetch product detail
      this.loaded = false;
      let res = await ProductApis.fetchById(this.$route.params.product_id);
      if(res.status != 200){
        // if product doesnot exist back to Store profile route
        this.va_snackbar({
          type: "warning",
          message:  "Cannot find the product."
        });
        return this.$router.push({ 
          name: 'StoreProfile', 
          params: { 
            business_slug: this.$route.params.business_slug,
            store_slug: this.$route.params.store_slug
          },
          query: this.$route.query,
        })
      }
    
      if(this.$store.getters.getLoggedInUserId){
        await UserApis.fetchFavProducts();
      }
      this.productDetail = res.data.payload;
      this.loaded = true;
      if(this.$store.getters.getLoggedInUserToken){
        // lets save the data on vbout
        VboutApis.productView(this.productDetail, Helpers.getLocationProductFullUrl(this, this.productDetail.id), this.vg_selectedStore.id);
      } 
    },


    goBack() {
      // Now while going back lets assign the location record, if has data then only insert for history
      // if(this.vg_storeProfileRecord.data.length == 0) {
      //   // clear all filter on search
      //    this.va_resetFilters();
      // }
      // this.va_setStoreProfileRecord({
      //   insertHistory: this.vg_storeProfileRecord.data.length == 0 ? false : true,
      // })

      // that measn it came from shop
      if(this.$route.query.category) {
        return this.$router.push({ 
          name: 'StoreProfile', params:{
            business_slug:  this.$route.params.business_slug,
            store_slug:  this.$route.params.store_slug,
          }, 
          query: this.$route.query 
        });
      }

      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage', query: this.$route.query });
    },

    /**
     * Move to page from breadcrumb
     */
    moveToPage(name, queryParams = null) {
       this.$router.push({ 
          name: name, 
          params: { 
            business_slug: this.$route.params.business_slug,
            store_slug: this.$route.params.store_slug
          },
          query: !_.isEmpty(queryParams) ? { ...queryParams, ...this.$route.query } :  this.$route.query,
        })
    },
    
    /**
     * Select location product variant
     */
    selectedLocationVariants(variants) {
      // First create unique variant and then on that variant add _is_stock_key
      // need to attach qty and is_active key as per single page design
      let getUniqueProductVarinats = Helpers.getUniqueProductVariants(this.productDetail.product_family, variants);
      return getUniqueProductVarinats.map((item) => {
        if( (item.available == true) && (item.no_of_units > item.inventory_threshold)){
          item._in_stock = true;
        } else {
          item._in_stock = false;
        }
        // Attach more keys
        item.is_active = false;
       // item.qty = 1; // by default 1 for every varaint
        return item;
      })
    },

    /**
     * Fetch out of stock notification subscribed list of all varinats by product id
     */
    async fetchOutofStockSubscribeVariants() {
      const self = this;
      // reset
      self.outofStockSubscribeVariants = [];
      let outofStockSubscribeNotificationRes = await UserApis.listOutOfstockNotification(this.productDetail.id);
      if( outofStockSubscribeNotificationRes.status == 200 ){ 
        outofStockSubscribeNotificationRes.data.payload.forEach(item => {
          // push
          self.outofStockSubscribeVariants.push({
            variant_id: item.location_product_varaint_id,
            id: item.id,
          });
        })
      }
    },
    
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setStoreProfileRecord: "storeprofile/setStoreProfileRecord",
      va_resetFilters: "searchproduct/setEmptySearchFilter",
      va_setPastSelectedLocationId: "location/setPastSelectedLocationId",
    })
  },
};
</script>
<style scoped>
.nab-bar-left {
  display: flex;
  flex-direction: row;
}
h1.title {
  margin-top: 9px;
}
.nav-bar-wrapper{
  display: flex;
  height: 100%;
}
.nab-bar-left{
  align-items: center;
}
</style>
